<template>
  <div class="tq-skeleton" aria-hidden="true" />
</template>

<style scoped>
.tq-skeleton { min-height: 1rem; border-radius: var(--tq-radius-md); background: linear-gradient(90deg, var(--tq-bg-muted), var(--tq-bg-elevated), var(--tq-bg-muted)); background-size: 200% 100%; animation: tq-skeleton 1.2s ease-in-out infinite; }
@keyframes tq-skeleton { to { background-position-x: -200%; } }
</style>
